export const CLOUD_LOGO = "https://customer-assets.emergentagent.com/job_buckhead-portal/artifacts/819gbv16_CPI-2024_Transparent.png";

export function resolveAsset(url) {
  if (!url) return url;
  if (url.startsWith("/")) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url;
}

export const STATUS_META = {
  open: { label: "Open", dot: "#3B82F6", bg: "bg-blue-50", text: "text-blue-700" },
  in_progress: { label: "In Progress", dot: "#F59E0B", bg: "bg-amber-50", text: "text-amber-700" },
  review: { label: "Review", dot: "#8B5CF6", bg: "bg-violet-50", text: "text-violet-700" },
  resolved: { label: "Resolved", dot: "#10B981", bg: "bg-emerald-50", text: "text-emerald-700" },
  closed: { label: "Closed", dot: "#64748B", bg: "bg-slate-100", text: "text-slate-600" },
};

export const STATUS_ORDER = ["open", "in_progress", "review", "resolved", "closed"];

export const PRIORITY_META = {
  low: { label: "Low", color: "#64748B", bg: "bg-slate-100 text-slate-700" },
  medium: { label: "Medium", color: "#3B82F6", bg: "bg-blue-50 text-blue-700" },
  high: { label: "High", color: "#F59E0B", bg: "bg-amber-50 text-amber-700" },
  urgent: { label: "Urgent", color: "#EF4444", bg: "bg-red-50 text-red-700" },
};

export const TYPE_META = {
  request: "Request",
  bug: "Bug",
  task: "Task",
  seo: "SEO",
  content: "Content",
};

export function applyTenant(primary, accent) {
  const root = document.documentElement;
  root.style.setProperty("--tenant-primary", primary || "#0EA5E9");
  root.style.setProperty("--tenant-accent", accent || "#3B82F6");
}

export function initials(name = "") {
  return name.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } catch { return "—"; }
}

export function timeAgo(iso) {
  if (!iso) return "";
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
}
